import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { StopSyncingFieldVisitsModal } from '@components/StopSyncingFieldVisitsModal';
import { addModal, removeModal } from '@state-mgmt/slices/appSlice';

export const useStopSyncingFieldVisitsModal = () => {
  const modalKey = 'stop-sync-visits-modal';
  const dispatch = useDispatch();

  const onClose = useCallback(() => {
    dispatch(removeModal({ key: modalKey }));
  }, [dispatch]);

  const displayModal = useCallback(() => {
    const children = <StopSyncingFieldVisitsModal onClose={onClose} />;
    dispatch(addModal({ key: modalKey, props: { visible: true, children, onClose } }));
  }, [dispatch, onClose]);

  return displayModal;
};
